import instance from "../apis/axiosConfig";
// CREATE
export const createService = (data) => instance.post("services/create", data);

// GET
export const getServices = (page, limit) =>
  instance.get(`services/getAll?page=${page}&limit=${limit}`);

// UPDATE
export const updateService = (id, data) =>
  instance.post(`services/update/${id}`, data);

// DELETE
export const deleteService = (id) =>
  instance.delete(`services/delete/${id}`);

// UPDATE IMAGE
export const updateServiceImage = (id, data) =>
  instance.post(`services/update-image/${id}`, data);

// PUBLISH STATUS
export const updatePublishStatus = (id, data) =>
  instance.post(`services/update-publish-status/${id}`, data);

export const updateServicePriority = (data) => {
  return instance.post("services/update-priority", data);
};

//Service Details CHILD APIs

export const createServiceDetails = (data) =>
  instance.post("/servicesDetails/create", data);

export const getServiceDetails = (serviceId, page = 1, limit = 10) =>
  instance.get(`/servicesDetails/getAll?serviceId=${serviceId}&page=${page}&limit=${limit}`);

export const updateServiceDetails = (id, data) =>
  instance.post(`/servicesDetails/update/${id}`, data);

export const deleteServiceDetails = (id) =>
  instance.delete(`/servicesDetails/delete/${id}`);

export const updateServiceDetailsImage = (id, data) =>
  instance.post(`/servicesDetails/update-image/${id}`, data);

export const updateServiceDetailsPublish = (id, data) =>
  instance.post(`/servicesDetails/update-publish-status/${id}`, data);